// extracted by mini-css-extract-plugin
export var searchHeader = "_88-0";
export var searchHeaderDark = "_88-1";